/**
 * Union of token types.
 */
export type Token = TextToken | StrongMarkerToken | EmphasisMarkerToken

/**
 * Types of tokens.
 */
export enum TokenType {
  Text,
  StrongMarker,
  EmphasisMarker,
}

/**
 * Text token.
 */
export interface TextToken {
  type: TokenType.Text
  value: string
}

/**
 * Text token.
 */
export interface StrongMarkerToken {
  type: TokenType.StrongMarker
  value: string
}

/**
 * Text token.
 */
export interface EmphasisMarkerToken {
  type: TokenType.EmphasisMarker
  value: string
}
